import { computed } from 'vue'
import { form, errors, isSubmitting, imageLoadError } from './state'
import { validateForm } from './methods/validate-form'
import { reloadImage, handleImageError } from './methods/handle-image'
import { submitForm } from './methods/submit-form'
import { loadSuggestionData } from './methods/load-suggestion-data'

/**
 * Öneri düzenleme formunu yönetmek için composable
 * @returns {Object} Form state ve metodları
 */
export const useSuggestionEdit = () => {
  /**
   * Formun geçerli olup olmadığını kontrol eder
   */
  const isFormValid = computed(() => {
    return form.suggestion.trim().length > 0
  })

  /**
   * Form state'ini temizler
   */
  const resetForm = () => {
    form.suggestion = ''
    form.currentImageUrl = ''
    form.currentVideoUrl = ''
    form.currentText = ''
    form.priority = 3
    
    Object.keys(errors).forEach(key => errors[key] = '')
    imageLoadError.value = false
  }

  return {
    // State
    form,
    errors,
    isSubmitting,
    imageLoadError,
    isFormValid,
    
    // Methods
    validateForm,
    reloadImage,
    handleImageError,
    submitForm,
    loadSuggestionData,
    resetForm
  }
}
